export const UPDATE_WINDOW_SIZE = "UPDATE_WINDOW_SIZE";

export function updateWindowSize(width, height) {
    return { type: UPDATE_WINDOW_SIZE, width, height }
}
